export default __webpack_public_path__ + "static/media/1.5bd42f7a.svg";